import {useEffect, useState} from 'react'

import {useFormik} from 'formik'
import {
  Button,
  Container,
  Form as BootstrapForm,
  Modal,
  Badge,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import * as Yup from 'yup'
import {toast} from 'react-toastify'

import {KTCard, KTCardBody, KTIcon} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'

import {useMutation, useLazyQuery} from '@apollo/client'
import {Spinner} from '../../components/Spinner'
import {useGetUser} from '../../hooks/useGetUser'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {hasPermission, parseId} from '../../helpers'
import {GET_ALL_CLIENTS} from '../../graphql/queries/getClients'
import type {
  ClientListEdge,
  ClientproductpriceSet,
  DataCreateClient,
  IDataClients,
} from '../../graphql/types/clientsTypes'
import {CREATE_UPDATE_CLIENT} from '../../graphql/mutations/clientMutations'
import {ALL_PERMISSIONS} from '../../helpers/consts'
import {ModalViewPrices} from '../../components/clients/ModalViewPrices'
import {useDisclosure} from '../../hooks/useDisclosure'
import {ModalAddPrice} from '../../components/clients/ModalAddPrice'
import {ModalDeletePrice} from '../../components/clients/ModalDeletePrice'
import {ModalEditPrice} from '../../components/clients/ModalEditPrice'

interface IInfoPrices {
  id: string
  name: string
  prices: ClientproductpriceSet
}

interface IInfoPriceDelete {
  price: string
  idPrice: string
  idProduct: string
  productName: string
  idClient: string
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('El nombre es obligatorio'),
  nit: Yup.string().required('Campo requerido'),
  phoneNumber: Yup.string().required('Campo requerido'),
  address: Yup.string().required('Campo requerido'),
})

export const ClientsPage = () => {
  const [gqlGetAllClients, {data, loading, error, refetch}] = useLazyQuery<IDataClients>(
    GET_ALL_CLIENTS,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const [gqlCreateUpdateClient, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<DataCreateClient>(CREATE_UPDATE_CLIENT)

  const [searchTerm, setSearchTerm] = useState('')
  const [showModalCreateUpdate, setShowModalCreateUpdate] = useState(false)
  const [idClientEdit, setIdClientEdit] = useState<null | string>(null)
  const [after, setAfter] = useState<string | null>(null)
  const [isPagination, setIsPagination] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const [dataArr, setDataArr] = useState<ClientListEdge[]>([])

  const {/* idOrganization, */ user} = useGetUser()

  const {isOpen, onClose, onOpen} = useDisclosure()
  const {
    isOpen: isOpenDeletePrice,
    onClose: onCloseDeletePrice,
    onOpen: onOpenDeletePrice,
  } = useDisclosure()
  const {
    isOpen: isOpenEditPrice,
    onClose: onCloseEditPrice,
    onOpen: onOpenEditPrice,
  } = useDisclosure()

  const [infoPriceClient, setInfoPriceClient] = useState<null | IInfoPrices>(null)
  const [infoAddPrice, setInfoAddPrice] = useState<null | {
    name: string
    id: string
    prevPrices: string[]
  }>(null)

  const {isOpen: isOpenAddPrice, onClose: onCloseAddPrice, onOpen: onOpenAddPrice} = useDisclosure()

  const [infoPrice, setInfoPrice] = useState<null | IInfoPriceDelete>(null)

  const formik = useFormik({
    initialValues: {
      nit: '',
      phoneNumber: '',
      address: '',
      name: '',
      postpaidSales: '',
    },
    validationSchema,
    onSubmit: (values) => {
      // Aquí puedes realizar la acción con los datos enviados por el formulario
      console.log(values)
      /* console.log('idOrganization', idOrganization)
      if (!idOrganization) return */
      gqlCreateUpdateClient({
        variables: {
          input: {
            ...values,
            id: idClientEdit ? parseId(idClientEdit) : undefined,
            // organization: parseId(idOrganization),
            postpaidSales: Boolean(values.postpaidSales),
          },
        },
      })
    },
  })

  useEffect(() => {
    const variables: {after: null | string; name?: string} = {
      after,
    }
    if (searchTerm) {
      variables.name = searchTerm
    }
    gqlGetAllClients({
      variables,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [after, searchTerm])

  useEffect(() => {
    if (error) {
      console.log('error', error)
    }
  }, [error])

  useEffect(() => {
    if (!data) return
    setIsSearch(false)
    if (isPagination) {
      setDataArr((prev) => [...prev, ...data.clientList.edges])
      return
    }
    setDataArr(data.clientList.edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.clientCreateUpdate.client?.id) {
      toast.success(`Cliente ${idClientEdit ? 'actualizado' : 'creado'} con éxito`)
      setIsPagination(false)
      setAfter(null)
      refetch()
      setShowModalCreateUpdate(false)
      formik.resetForm()
    } else if (
      dataCreate?.clientCreateUpdate.errors &&
      dataCreate?.clientCreateUpdate.errors.length > 0
    ) {
      toast.error('Error: ' + dataCreate?.clientCreateUpdate.errors[0].messages)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  useEffect(() => {
    if (errorCreate) {
      toast.error('Error: ' + errorCreate.message)
    }
  }, [errorCreate])

  const handleClose = () => {
    setShowModalCreateUpdate(false)
  }
  const handleSubmitSearchName = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {name} = Object.fromEntries(new FormData(e.currentTarget))
    if (name.toString() === '') {
      setAfter(null)
      setSearchTerm('')
      return
    }
    if (name.toString().length < 3) return
    setSearchTerm(name.toString())
    setIsSearch(true)
  }
  const updateInfoAddPrice = (info: {name: string; id: string; prevPrices: string[]}) => {
    setInfoAddPrice(info)
  }
  if (loading && !isPagination && !isSearch) {
    return (
      <div>
        <PageTitle
          breadcrumbs={[
            {
              title: 'CMR',
              path: '/',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
        >
          Lista de clientes
        </PageTitle>
        <KTCard>
          <div style={{height: '40vh'}}>
            <KTCardBody className='py-4 d-flex align-items-center justify-content-center h-100'>
              <Spinner />
            </KTCardBody>
          </div>
        </KTCard>
      </div>
    )
  }
  const canterasList = dataArr
  const permissions = user?.tokenAuth.permissions ?? ['']
  return (
    <div>
      <BreadcrumbJeisat
        title='Lista de clientes'
        breadcrumb={[
          {
            title: 'CRM',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <>
            {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_CLIENTE) ? (
              <Button
                onClick={() => {
                  setShowModalCreateUpdate(true)
                  setIdClientEdit(null)
                }}
                className='d-flex align-items-center gap-1'
              >
                <i className='fa fa-plus' /> Agregar cliente
              </Button>
            ) : null}
          </>
        }
      />

      <KTCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            {/* begin::Search */}
            <form onSubmit={handleSubmitSearchName}>
              <div className='d-flex align-items-center position-relative my-1'>
                <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                <input
                  type='search'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid w-250px ps-14'
                  placeholder='Buscar cliente'
                  name='name'
                />
              </div>
            </form>
            {/* end::Search */}
          </div>
          {loading && isSearch && <Spinner size='20px' />}
          {/* begin::Card toolbar */}
          {/*  <div className='card-toolbar'>
            {/* begin::Group actions
            <UsersListToolbar />
            {/* end::Group actions 
          </div> */}
          {/* end::Card toolbar */}
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            {canterasList.length > 0 ? (
              <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
              >
                <thead className='fw-bold'>
                  <tr className='text-start text-gray-900 fw-bold fs-7 text-uppercase gs-0'>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>NIT</th>
                    <th>Teléfono</th>
                    <th>Dirección</th>
                    <th>Pospago</th>
                    <th />
                  </tr>
                </thead>
                <tbody className='text-gray-700'>
                  {canterasList.map(({node}, idx) => (
                    <tr key={node.id}>
                      <td>{idx + 1}</td>
                      <td>{node.name}</td>
                      <td>{node.nit}</td>
                      <td>{node.phoneNumber}</td>
                      <td>{node.address}</td>
                      <td>
                        {node.postpaidSales ? (
                          <Badge bg='success'>SI</Badge>
                        ) : (
                          <Badge bg='dark' className='text-light'>
                            NO
                          </Badge>
                        )}
                      </td>
                      <td>
                        <div>
                          <button
                            className='border-0 p-0 m-0 bg-transparent me-4 hover-bg-color-dark text-secondary'
                            onClick={() => {
                              setIdClientEdit(node.id)
                              formik.setValues({
                                address: node.address,
                                name: node.name,
                                nit: node.nit,
                                phoneNumber: node.phoneNumber,
                                postpaidSales: node.postpaidSales ? 'SI' : '',
                              })
                              setShowModalCreateUpdate(true)
                            }}
                            title='Editar'
                          >
                            <i className='fa fa-pencil' style={{color: 'inherit'}} />
                          </button>
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip id={`button-tooltip-${parseId(node.id)}`} {...props}>
                                Ver precios
                              </Tooltip>
                            )}
                          >
                            <Button
                              variant='outline-dark'
                              size='sm'
                              onClick={() => {
                                onOpen()
                                setInfoPriceClient({
                                  id: node.id,
                                  name: node.name,
                                  prices: node.clientproductpriceSet,
                                })
                              }}
                            >
                              <i className='fa fa-eye' style={{color: 'inherit'}} />
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            overlay={(props) => (
                              <Tooltip id={`button-price-${parseId(node.id)}`} {...props}>
                                Agregar precio
                              </Tooltip>
                            )}
                          >
                            <Button
                              variant='outline-dark'
                              size='sm'
                              onClick={() => {
                                onOpenAddPrice()
                                updateInfoAddPrice({
                                  id: node.id,
                                  name: node.name,
                                  prevPrices: node.clientproductpriceSet.edges.map(
                                    ({node: nodePrev}) => nodePrev.product.id
                                  ),
                                })
                              }}
                            >
                              <i className='bi bi-cash-coin' style={{color: 'inherit'}} />
                            </Button>
                          </OverlayTrigger>
                        </div>
                        {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div
                className='d-flex text-center w-100 align-items-center justify-content-center'
                style={{height: '30vh'}}
              >
                <div>No hay clientes registrados</div>
              </div>
            )}
          </div>
          {loading && isPagination && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Spinner size='24px' />
            </div>
          )}
          {data?.clientList.pageInfo.hasNextPage && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Button
                size='sm'
                variant='info'
                onClick={() => {
                  setIsPagination(true)
                  setAfter(data.clientList.pageInfo.endCursor)
                }}
              >
                Cargar más clientes
              </Button>
            </div>
          )}
          {/* {isLoading && <UsersListLoading />} */}
        </KTCardBody>
      </KTCard>

      <Modal show={showModalCreateUpdate} onHide={handleClose}>
        <BootstrapForm onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>{idClientEdit ? 'Editar' : 'Crear'} cliente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container className='d-flex flex-column gap-4'>
              <BootstrapForm.Group controlId='name'>
                <BootstrapForm.Label>Nombre:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el nombre'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  isInvalid={formik.touched.name && !!formik.errors.name}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.name}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='nit'>
                <BootstrapForm.Label>NIT:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el nit'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nit}
                  isInvalid={formik.touched.nit && !!formik.errors.nit}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.nit}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='phoneNumber'>
                <BootstrapForm.Label>Número de teléfono:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el número de teléfono'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phoneNumber}
                  isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.phoneNumber}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='address'>
                <BootstrapForm.Label>Dirección:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese el dirección'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                  isInvalid={formik.touched.address && !!formik.errors.address}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.address}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='postpaidSales'>
                <BootstrapForm.Label>¿Acepta Postpago?</BootstrapForm.Label>
                <BootstrapForm.Select
                  aria-label='postpaidSales'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.postpaidSales}
                  isInvalid={formik.touched.postpaidSales && !!formik.errors.postpaidSales}
                >
                  <option value=''>NO</option>
                  <option value='SI'>SI</option>
                </BootstrapForm.Select>
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.postpaidSales}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type='button'
              variant='secondary'
              onClick={() => {
                handleClose()
                setIdClientEdit(null)
                formik.resetForm()
              }}
            >
              Cancelar
            </Button>
            <Button
              type='submit'
              variant='primary'
              disabled={loadingCreate}
              className='d-flex align-items-center gap-2'
            >
              {loadingCreate && <Spinner color='light' size='14px' />}
              {/* <Spinner color='light' size='14px' /> */}
              {idClientEdit ? 'Editar' : 'Agregar'} cliente
            </Button>
          </Modal.Footer>
        </BootstrapForm>
      </Modal>

      {isOpen && infoPriceClient && (
        <ModalViewPrices
          isOpen={isOpen}
          onClose={onClose}
          infoPriceClient={infoPriceClient}
          onOpenAddPrice={onOpenAddPrice}
          updateInfoAddPrice={updateInfoAddPrice}
          onOpenEditPrice={onOpenEditPrice}
          onOpenDeletePrice={onOpenDeletePrice}
          setInfoEditPrice={setInfoPrice}
        />
      )}
      {isOpenAddPrice && infoAddPrice && (
        <ModalAddPrice
          isOpen={isOpenAddPrice}
          onClose={onCloseAddPrice}
          infoAddPrice={infoAddPrice}
          refetch={refetch}
        />
      )}

      {isOpenDeletePrice && infoPrice && (
        <ModalDeletePrice
          isOpen={isOpenDeletePrice}
          onClose={onCloseDeletePrice}
          info={infoPrice}
          refetch={refetch}
          onOpenPrices={onOpen}
        />
      )}
      {isOpenEditPrice && infoPrice && (
        <ModalEditPrice
          isOpen={isOpenEditPrice}
          onClose={onCloseEditPrice}
          info={infoPrice}
          refetch={refetch}
          onOpenPrices={onOpen}
        />
      )}
    </div>
  )
}
